export const circInOut = {
    ease: [0.86, 0, 0.07, 1],
    duration: 0.3
};

export const slideIn = {
    initial: {
        opacity: 0,
        y: "100%"
    },
    animate: {
        opacity: 1,
        y: "0%",
        transition: {
            ...circInOut
        }
    },
    exit: {
        opacity: 0,
        y: "100%",
        transition: {
            ...circInOut
        }
    }
};
